import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=51f58847&scoped=true&"
import script from "./Tips.vue?vue&type=script&lang=ts&"
export * from "./Tips.vue?vue&type=script&lang=ts&"
import style0 from "./Tips.vue?vue&type=style&index=0&id=51f58847&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f58847",
  null
  
)

export default component.exports